module.exports = __webpack_public_path__ + "static/medicalDS-b6ea81cf29771956e75455c39c69a089.png";